import React, { useEffect, useState } from "react";
import styled from "styled-components";

import { list_of_divisions_url } from "../utils/constants";
import { Link } from "react-router-dom";

import axios from "axios";

const T7DivisionListPage = () => {
  const [divisionsInProgress, setDivisionsInProgress] = useState(true);
  const [divisionsError, setDivisionsError] = useState(false);
  const [divisionsCompleted, setDivisionsCompleted] = useState(false);
  const [divisions, setDivisions] = useState([]);

  const loadDivisions = async () => {
    const url = list_of_divisions_url;

    try {
      setDivisionsInProgress(true);
      const response = await axios.get(url);
      if (response.status === 200) {
        const divs = response.data.sort((a, b) =>
          a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1
        );
        setDivisions(divs);
        setDivisionsInProgress(false);
        setDivisionsCompleted(true);
        return true;
      } else {
        console.log(`(${response.status}) response: ${response.data}`);
        setDivisionsInProgress(false);
        setDivisionsError(true);
        return false;
      }
    } catch (error) {
      setDivisionsInProgress(false);
      setDivisionsError(true);
      return false;
    }
  };

  useEffect(() => {
    loadDivisions();
  }, []);

  return (
    <Wrapper>
      <DivisionList>
        {divisionsInProgress ? (
          <div className="loading">
            <div className="lds-dual-ring"></div>
          </div>
        ) : (
          ""
        )}
        {divisionsError ? (
          <div className="error">
            Ha ocurrido un error cargando las divisiones
          </div>
        ) : (
          ""
        )}

        {/* <p>En breve publicaremos toda la info.</p> */}
        {divisionsCompleted
          ? divisions.map((division) => {
              return (
                <Division key={division.divisionId}>
                  <img src={division.image} alt={division.name} />
                  <div className="group-list">
                    {division.groups.map((group) => {
                      return (
                        <span key={`${division.divisionId}-${group.groupId}`}>
                          <Link to={`/season/7/group/${group.groupId}`}>
                            {group.name}
                          </Link>
                        </span>
                      );
                    })}
                  </div>
                </Division>
              );
            })
          : ""}
      </DivisionList>
    </Wrapper>
  );
};

const Wrapper = styled.main`
  margin-top: 10vh;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--clr-black);
  background-color: var(--clr-grey-1);
  flex-direction: column;

  h3,
  p {
    margin: 0.4rem;
  }

  a {
    color: var(--clr-black);
  }

  a:hover {
    color: var(--clr-red-dark);
  }

  h3 {
    margin: 1rem;
  }

  .container {
    width: 100%;
    height: 100vh;
    position: absolute;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }

  .container-notification {
    width: 100vw;
    height: 100vh;
    position: absolute;
    right: 0;

    @media (max-width: 992px) {
      display: flex;
      justify-content: center;
      right: auto;
    }
  }
  .logo {
    width: 20rem;
  }
  .background-video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: -10;
    position: absolute;
  }
`;

const Division = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  padding: 1rem;

  img {
    width: 4rem;
    height: 4rem;
  }
  span {
    width: 100%;
    margin: 1.5rem;
    display: flex;
    align-items: center;
  }

  .div-name {
    min-width: 10rem;
  }

  .group-list {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-wrap: wrap;
    span {
      margin-top: 0.3rem;
      margin-bottom: 0.3rem;
    }
  }

  @media (max-width: 992px) {
    width: 30vw;
  }
`;

const DivisionList = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: flex-start;

  @media (max-width: 992px) {
    justify-content: space-between;
  }
`;

export default T7DivisionListPage;
